export default "__VITE_ASSET__CJjTP0yC__"